import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo04({ data }: Readonly<ModeloDefaultProps>) {

    const banners = data.banners.slice(0, 3)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo4 container">
            <div className="item-banner flex center justify-center">
                <div className="banner-column banner-size flex column">
                    {banners.slice(0, 2).map(currentBanner => (
                        <ConteudoBanner key={currentBanner.id} data={{
                            banner: currentBanner,
                            device: data.device
                        }} />
                    ))}
                </div>

                {banners[2] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[2],
                            device
                        }} />
                    </div>
                )}
            </div>
        </div>
    )
}